//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import { delay } from "redux-saga";
import importservice from "../../services/import";
import { DateTime, persist, array, pointName, number } from "../../utils";
import ruleservice from "../../services/rules";
import moment from "moment-timezone";
import pointsservice from "../../services/points";
import { types as sitetreetypes } from "../../services/SiteTree/redux";
import { types as searchbartypes } from "../../components/SearchBar/redux";
import { types as timetypes } from "../../redux/timeRedux";

const initialState = {
	data: [],

   onPage: false,

	enabledFilter: null,
	moreDetails: null,
	isBusy: false,
	query: "",
	errors: [],

	numOfEnabled: 0,
	numOfDisabled: 0,
};

const persistConf = {
	whitelist: [""]
};

/////////
//types
export const types = {
	GET_DATA: "screens/operations/GET_DATA",
	ON_GET_DATA: "screens/operations/ON_GET_DATA",
	ON_GET_FAIL_DATA: "screens/operations/ON_GET_FAIL_DATA",

	GET_OUTCOMES: "screens/operations/GET_OUTCOMES",
	ON_GET_OUTCOMES: "screens/operations/ON_GET_OUTCOMES",
	GET_ERRORS: "screens/operations/GET_ERRORS",
	ON_GET_ERRORS: "screens/operations/ON_GET_ERRORS",
	GET_POINT_OUTCOMES: "screens/operations/GET_POINT_OUTCOMES",
	ON_GET_POINT_OUTCOMES: "screens/operations/ON_GET_POINT_OUTCOMES",
	SHOW_MORE: "screens/operations/SHOW_MORE",
	SET_QUERY: "screens/operations/SET_QUERY",
	ERROR: "screens/operations/ERROR",
	SET_EXTRA_DETAILS: "screens/operations/SET_EXTRA_DETAILS",
	TOGGLE_RULE: "screens/operations/TOGGLE_RULE",
	SET_ENABLED_FILTER: "screens/operations/SET_ENABLED_FILTER",
	SET_ENABLED_DISABLED: "screens/operations/SET_ENABLED_DISABLED",

	SET_ON_PAGE: "screens/operations/SET_ON_PAGE",
	ON_SET_ON_PAGE: "screens/operations/ON_SET_ON_PAGE",
};

///////////
//reducers
const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.GET_DATA:
			case types.GET_OUTCOMES:
			case types.GET_ERRORS:
			case types.GET_POINT_OUTCOMES:
				return { ...state, isBusy: true };
			case types.ON_GET_DATA:
				return { ...state, data: action.payload.data };
			case types.ON_GET_FAIL_DATA:
				return { ...state, isBusy: false, failData: action.payload.data };
			case types.ON_GET_OUTCOMES: {
				let news = state.data.slice();
				const rule = news.find(x => x.ruleInstanceId === action.payload.ruleInstanceId);
				rule.outcomes = action.payload.outcomes;
				return { ...state, isBusy: false, data: news, moreDetails: { ruleOutcomes: rule.outcomes } };
			}
			case types.SET_ON_PAGE: 
				return { ...state, onPage: action.payload };
			case types.ON_GET_POINT_OUTCOMES: {
				let news = state.data.slice();
				const rule = news.find(x => x.ruleInstanceId === action.payload.ruleInstanceId);
				rule.pointOutcomes = action.payload.outcomes;
				return { ...state, isBusy: false, data: news, moreDetails: { points: rule.pointOutcomes } };
			}
			case types.ON_GET_ERRORS: {
				let news = state.data.slice();
				const rule = news.find(x => x.ruleInstanceId === action.payload.ruleInstanceId);
				rule.errors = action.payload.errors;
				return { ...state, isBusy: false, data: news, moreDetails: { errors: rule.errors } };
			}
			case types.SET_QUERY:
				return { ...state, query: action.payload.query };
			case types.SHOW_MORE:
				return { ...state, moreDetails: action.payload.row };

			case types.ERROR:
				return { ...state, isBusy: false, errors: state.errors.concat(action.payload).slice(-10) };
		
			case types.SET_EXTRA_DETAILS: {
				return { ...state, numRun: action.payload.run, numErrors: action.payload.errors }
			}
			case types.SET_ENABLED_FILTER: {
				return { ...state, enabledFilter: action.payload };
			}
			case types.SET_ENABLED_DISABLED: {
				return { ...state, numOfEnabled: action.payload.enabled, numOfDisabled: action.payload.disabled }
			}
			default:
				return state;
		}
	}
};
export const reducer = persist("operations", reducers.reducer, persistConf);

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.getData(), 
			this.onSearch(), 
			this.getOutcomes(), 
			this.getPointOutcomes(), 
			this.getErrors(),
			this.onMenuToggle(),
			this.onToggleRule(),
			this.onSetOnPage(),
		]);
	},

	*onSetOnPage() {
		yield takeEvery(types.SET_ON_PAGE, function*({ payload }) {
			if(payload) {
				yield put(actions.onSetOnPage());
			}
		});
	},

	*onMenuToggle() {
		yield takeEvery("screens/menu/TOGGLE_OPEN", function*({ payload }) {
			yield delay(600);
		});
	},

	*onToggleRule() {
		yield takeEvery(types.TOGGLE_RULE, function*({ payload }) {
			yield call(ruleservice.SetEnabled, payload.ruleInstanceId, payload.enabled);

			yield delay(500);

			yield put(actions.getData());
		});
	},

	*getErrors() {
		yield takeEvery(types.GET_ERRORS, function*({ payload }) {
			let { currentSite, time } = yield select(x => ({
				currentSite: x.sitetree.currentSite,
				time: x.time.timeRange
			}));
			const from = time.startDate;
			const to = time.endDate;
			const result = yield call(ruleservice.GetRuleErrors, payload.ruleInstanceId, from, to);

			if (result instanceof Error) {
				yield put(actions.error(result));
			} else {
				yield put(actions.onGetErrors(payload.ruleInstanceId, result));
			}
		});
	},

	*getPointOutcomes() {
		yield takeEvery(types.GET_POINT_OUTCOMES, function*({ payload }) {
			let { currentSite, time } = yield select(x => ({
				currentSite: x.sitetree.currentSite,
				time: x.time.timeRange
			}));
			const from = time.startDate;
			const to = time.endDate;
			const result = yield call(ruleservice.GetRulePointOutcomes, payload.ruleInstanceId, from, to);

			if (result instanceof Error) {
				yield put(actions.error(result));
			} else {
				const pointIds = array.removeDuplicates(result.map(x => x.pointId).filter(x => x));
				const obs = yield all(pointIds.map(pointId => call(pointsservice.TrendableObjectGetObject, pointId)));
				const utcOffset = moment().utcOffset();

				for (let index = 0; index < result.length; index++) {
					const outcome = result[index];
					outcome.startSiteLocal =
						outcome.startSiteLocal && moment(outcome.startSiteLocal).subtract(utcOffset, "minutes");

					outcome.endSiteLocal =
						outcome.endSiteLocal && moment(outcome.endSiteLocal).subtract(utcOffset, "minutes");

					if (outcome.pointId) {
						const trendableobj = obs.find(x => x.objectID == outcome.pointId);
						outcome.point = pointName.formatDescription(trendableobj);
					}
				}

				yield put(actions.onGetPointOutcomes(payload.ruleInstanceId, result));
			}
		});
	},

	*getOutcomes() {
		yield takeEvery(types.GET_OUTCOMES, function*({ payload }) {
			let { currentSite, time } = yield select(x => ({
				currentSite: x.sitetree.currentSite,
				time: x.time.timeRange
			}));
			const from = time.startDate;
			const to = time.endDate;
			const result = yield call(ruleservice.GetRuleOutcomes, payload.ruleInstanceId, from, to);

			if (result instanceof Error) {
				yield put(actions.error(result));
			} else {
				const pointIds = array.removeDuplicates(
					array
						.selectMany(result, x => x.pointSnapshot)
						.map(x => x.pointId)
						.filter(x => x)
				);

				const obs = yield all(pointIds.map(pointId => call(pointsservice.TrendableObjectGetObject, pointId)));
				const utcOffset = moment().utcOffset();

				for (let index = 0; index < result.length; index++) {
					const outcome = result[index];
					outcome.startSiteLocal =
						outcome.startSiteLocal && moment(outcome.startSiteLocal).subtract(utcOffset, "minutes");

					outcome.endSiteLocal =
						outcome.endSiteLocal && moment(outcome.endSiteLocal).subtract(utcOffset, "minutes");

					for (let ff = 0; ff < outcome.pointSnapshot.length; ff++) {
						const snap = outcome.pointSnapshot[ff];
						if (snap.pointId) {
							const trendableobj = obs.find(x => x.objectID == snap.pointId);
							snap.point = pointName.formatDescription(trendableobj);
						}
					}
				}

				yield put(actions.onGetOutcomes(payload.ruleInstanceId, result));
			}
		});
	},

	*onSearch() {
		yield takeEvery([searchbartypes.SEARCH_BAR_SUBMIT, searchbartypes.SEARCH_BAR_UPDATED], function*({ payload }) {
			if (payload.searchBarId === "ops/List") {
				yield put(actions.search(payload.query));
			}
		});
	},

	*getData() {
		yield takeEvery(
			[types.GET_DATA, timetypes.UPDATE_TIME_RANGE, sitetreetypes.SET_CURRENT_SITE, types.SET_QUERY, types.SET_ENABLED_FILTER, types.ON_SET_ON_PAGE],
			function*({ payload }) {
				let { currentSite, time, query, enabledFilter, onPage } = yield select(x => ({
					currentSite: x.sitetree.currentSite,
					time: x.time.timeRange,
					query: x.operations.query,
					enabledFilter: x.operations.enabledFilter,
					onPage: x.operations.onPage
				}));
				if(!onPage) {
					return;
				}

				if (!currentSite) {
					yield take(sitetreetypes.ON_LOAD);
					currentSite = yield select(x => x.sitetree.currentSite);
				}
				const from = moment(time.startDate);
				const to = moment(time.endDate);

				const result = yield call(ruleservice.GetRuleStats, currentSite.name, from, to, query || null, enabledFilter);

				if (result instanceof Error) {
					yield put(actions.error(result));
				} else {
					const utcOffset = moment().utcOffset();

					var numOfEnabled = 0;
					var numOfDisabled = 0;
					for (let index = 0; index < result.length; index++) {
						const item = result[index];
						item.lastOutputDate =
							item.lastOutputDate && moment(item.lastOutputDate).subtract(utcOffset, "minutes");
						if(item.enabled) {
							numOfEnabled++;
						} else {
							numOfDisabled++;
						}
					}

					yield put(actions.onGetData(result));
					yield put(actions.setEnabledDisabled(numOfEnabled, numOfDisabled));
				}

				const result2 = yield call(ruleservice.GetRuleFailStats, currentSite.name, from, to);
				if(result2 instanceof Error) {
					yield put(actions.error(result2));
				} else {
					const utcOffset = moment().utcOffset();

					for(let index2 = 0; index2 < result2.length; index2++) {
						const item = result2[index2];
						item.dayStartSiteLocal = item.dayStartSiteLocal && moment(item.dayStartSiteLocal);
					}

					yield put(actions.onGetFailData(result2));
				}
			}
		);
	}
};

////////
//actions
export const actions = {
	setEnabledDisabled(enabled, disabled) {
		return {
			type: types.SET_ENABLED_DISABLED,
			payload: { enabled, disabled }
		}
	},
	toggleRule(ruleInstanceId, enabled) {
		return {
			type: types.TOGGLE_RULE,
			payload: { ruleInstanceId, enabled }
		}
	},
	setExtraDetails(run, errors) {
		return {
			type: types.SET_EXTRA_DETAILS,
			payload: { run, errors }
		}
	},
	search(query) {
		return {
			type: types.SET_QUERY,
			payload: { query }
		};
	},

	getData() {
		return {
			type: types.GET_DATA,
			payload: {}
		};
	},

	onGetData(data) {
		return {
			type: types.ON_GET_DATA,
			payload: { data }
		};
	},
	onGetFailData(data) {
		return {
			type: types.ON_GET_FAIL_DATA,
			payload: { data }
		}
	},

	showMore(row) {
		return {
			type: types.SHOW_MORE,
			payload: { row }
		};
	},

	getOutcomes(ruleInstanceId) {
		return {
			type: types.GET_OUTCOMES,
			payload: { ruleInstanceId }
		};
	},

	onGetOutcomes(ruleInstanceId, outcomes) {
		return {
			type: types.ON_GET_OUTCOMES,
			payload: { ruleInstanceId, outcomes }
		};
	},

	getErrors(ruleInstanceId) {
		return {
			type: types.GET_ERRORS,
			payload: { ruleInstanceId }
		};
	},

	onGetErrors(ruleInstanceId, errors) {
		return {
			type: types.ON_GET_ERRORS,
			payload: { ruleInstanceId, errors }
		};
	},

	getPointOutcomes(ruleInstanceId) {
		return {
			type: types.GET_POINT_OUTCOMES,
			payload: { ruleInstanceId }
		};
	},

	onGetPointOutcomes(ruleInstanceId, outcomes) {
		return {
			type: types.ON_GET_POINT_OUTCOMES,
			payload: { ruleInstanceId, outcomes }
		};
	},

	changeTime(time) {
		return {
			type: types.CHANGE_TIME,
			payload: { time: time.selection }
		};
	},

	error(error) {
		return {
			type: types.ERROR,
			payload: error
		};
	},

	
	setEnabledFilter(fil) {
		return {
			type: types.SET_ENABLED_FILTER,
			payload: fil
		}
	},
	setOnPage(payload) {
		return {
			type: types.SET_ON_PAGE,
			payload
		}
	},
	onSetOnPage(payload) {
		return {
			type: types.ON_SET_ON_PAGE,
			payload
		}
	}
};



// WEBPACK FOOTER //
// ./src/ui/Operations/redux.js